export class BrandModel {
  constructor(item) {
    const { id, name, categoryId, categoryName } = item
    this.id = Number(id) || undefined
    this.name = name || undefined
    this.categoryId = categoryId || undefined
    this.categoryName = categoryName || undefined
  }
}

export class CategoryModel {
  constructor(item) {
    const { id, anName, name } = item
    this.id = Number(id) || undefined
    this.anName = anName || undefined
    this.name = name || undefined
  }
}
